import React from 'react';
import { LocalParticipant, RemoteParticipant, Room } from 'livekit-client';

import { Action } from './actions';

export interface State {
  space: Room | null;
  participants: Array<RemoteParticipant>;
  localParticipant: LocalParticipant | null;
  isInitialized: boolean;
  startAudioIssue: boolean;
  isBusy: boolean;
}

export type PubNubMessage<T> = T;

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'SET_INITIALIZATION_STATE': {
      return { ...state, isInitialized: action.payload };
    }

    case 'SET_IS_BUSY': {
      return { ...state, isBusy: action.payload };
    }

    case 'SET_SPACE': {
      return { ...state, space: action.payload };
    }

    case 'ADD_PARTICIPANT': {
      const clonedParticipants = [...state.participants];
      const targetIndex = state.participants.findIndex((p) => p.identity === action.payload.identity);

      if (targetIndex >= 0) {
        clonedParticipants.splice(targetIndex, 1, action.payload);
      } else {
        clonedParticipants.push(action.payload);
      }

      return { ...state, participants: clonedParticipants };
    }

    case 'SET_PARTICIPANTS': {
      return { ...state, participants: action.payload };
    }

    case 'SET_START_AUDIO_ISSUE': {
      return { ...state, startAudioIssue: action.payload };
    }

    case 'RESET_PARTICIPANTS': {
      return { ...state, participants: [] };
    }

    case 'REMOVE_PARTICIPANT': {
      return {
        ...state,
        participants: state.participants.filter(
          (currentParticipant) => currentParticipant.identity !== action.payload.identity,
        ),
      };
    }

    case 'SET_LOCAL_PARTICIPANT': {
      return { ...state, localParticipant: action.payload };
    }

    default: {
      return state;
    }
  }
};

export const initialState: State = {
  space: null,
  participants: [],
  localParticipant: null,
  isInitialized: false,
  startAudioIssue: false,
  isBusy: false,
};

export const Context = React.createContext<{
  state: State;
  dispatch: React.Dispatch<Action>;
}>({
  state: initialState,
  dispatch: () => undefined,
});

export const useContextReducer = () => {
  return React.useReducer(reducer, initialState);
};

export const useLiveStreamContext = () => React.useContext(Context);
